import React, { Component } from 'react'
import DigitalSidebar from './DigitalSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

export default class Plagiarism extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Digital Library" image="banner/library-3.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h4 className="title">Plagiarism Checking Tool </h4>
                    </div>
                  </div>
                  <div className="ttm-service-description"> 
                    <div className="row">
                      <div className="col-md-5" style={{ margin: "auto" }}>
                        <div className="ttm_single_image-wrapper">
                          <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/digital/Plagiarism.jpg"} alt="single-img-eighteen" />
                        </div>
                      </div>
                      <div className="col-md-7" style={{ margin: "auto" }}>
                        <ul className="ttm-list ttm-list-style-icon">
                          <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">We are using DrillBit software as a plagiarism checking tool. The DSI community can avail this facility to check the plagiarism of the research papers, Ph.D thesis and other articles.</span></li>
                          <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">DrillBit is an Internet-based plagiarism detection service and  similarity checking tool subscribed through VTU Consortium.</span></li>
                          <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">DrillBit is to check submitted documents against its database and the content of other websites with the aim of  identifying plagiarism. Results can identify similarities with existing sources and can also be used in formative assessment to help students learn to avoid plagiarism and improve their writing.</span></li>
                          <li><i className="fa fa-check-circle ttm-textcolor-skincolor" /><span className="ttm-list-li-content">The projects and thesis submitted by students are stored in a database used to check for plagiarism. This prevents one student from using another student's paper, by identifying matching text between papers.</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DigitalSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    )
  }
}
